import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { BrandsService } from 'src/app/core/services/brands.service';
import { vendorService } from 'src/app/core/services/vendor.service';
import { brand, brandList } from 'src/app/models/brand';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'megastore-admin-assign-vendor',
  templateUrl: './assign-vendor.component.html',
  styleUrls: ['./assign-vendor.component.scss']
})
export class AssignVendorComponent implements OnInit, OnDestroy {
  vendors: any[] = [];
  selectedVendors: string = '';
  private destroy$ = new Subject<void>();
  isMegaStoreVendor: boolean = false;
  outlets: any[] = [];
  selectedOutlet: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { productId: string; assignedVendors?: string[] },
    private dialogRef: MatDialogRef<AssignVendorComponent>,
    private brandsService: BrandsService,
    private vendorService: vendorService,
    private spinnerService: SpinnerService,
    private toasterService: ToasterService,
    private translateService: TranslateService
  ) {
    if (data.assignedVendors) {
      this.selectedVendors = data.assignedVendors[0] || '';
      console.log("selectedVendors", this.selectedVendors);
    }
  }

  ngOnInit(): void {
    this.loadBrands();
  }

  loadBrands(): void {
    this.spinnerService.addToLoader('loadBrands');
    this.brandsService
      .getAllVendorList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spinnerService.removeFromLoader('loadBrands');
          this.vendors = res || [];
        },
        error: () => {
          this.spinnerService.removeFromLoader('loadBrands');
        }
      });
  }

  onVendorSelectionChange(selectedBrandIds: string): void {
    this.selectedVendors = selectedBrandIds;
    this.selectedOutlet = '';
    this.getVendorOutlets();
  }

  save(): void {
    if (this.selectedVendors !== '' && !this.isMegaStoreVendor && this.selectedOutlet === '') {
      this.toasterService.errToastr(
        this.translateService.instant('PleaseSelectOutlet')
      );
      return;
    }
    this.spinnerService.addToLoader('assignBrands');
    const payload: any = {
      vendorId: this.isMegaStoreVendor ? null : this.selectedVendors,
      productId: this.data.productId,
      outletId: this.isMegaStoreVendor ? null : this.selectedOutlet,
      assignTo: this.isMegaStoreVendor ? 'MegaStore' : 'Vendor'
    };
    console.log(payload);
    this.vendorService
      .assignVendor(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.spinnerService.removeFromLoader('assignBrands');
          this.toasterService.successToastr(
            this.translateService.instant('VendorsAssignedSuccessfully')
          );
          this.dialogRef.close(this.isMegaStoreVendor ? 'MegaStore' : 'Vendor');
        },
        error: () => {
          this.spinnerService.removeFromLoader('assignBrands');
        }
      });
  }

  getVendorOutlets(): void {
    this.spinnerService.addToLoader('getVendorOutlets');
    this.vendorService.getOutletList('', this.selectedVendors).subscribe({
      next: (res: any) => {
        this.spinnerService.removeFromLoader('getVendorOutlets');
        this.outlets = res.outlets || [];
      }
    }); 
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

